import React, { FunctionComponent } from 'react';

import { useSelector } from 'react-redux';
import { Route, Switch } from 'react-router-dom';

import { CallPage } from '../../../../../../pages/call';
import type { ErrorPageType } from '../../../../../components/error-page/types';
import { selectIsTelemessengerExpEnabled } from '../../../../flags/selectors';

interface OnlyCallsViewProps {
    errorPageType: ErrorPageType | null;
}

export const OnlyCallsView: FunctionComponent<OnlyCallsViewProps> = ({ errorPageType }) => {
    const isTelemessengerExpEnabled = useSelector(selectIsTelemessengerExpEnabled);

    if (errorPageType) {
        return null;
    }

    return (
        <Switch>
            <Route path="/j/:id">
                <CallPage />
            </Route>
            {isTelemessengerExpEnabled && (
                <Route path="/private-join/:id">
                    <CallPage />
                </Route>
            )}
        </Switch>
    );
};
